module.exports = "/_next/static/images/CustomizeData@2x-c55e10ed86b50580b12738dfc231ba4b.png";